import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import './SameAddress.css';

import { SalesContext } from 'src/Context/SalesContext';

import { checkInputValidity } from 'src/Utility/utility';
import { FormFieldLabel } from 'src/StyledComponents';
import VettingInput from 'src/Components/Common/VettingInput/VettingInput';
import VettingDropDown from 'src/Components/Common/VettingDropDown/VettingDropDown';

const SameAddress = (props) => {
  const context = useContext(SalesContext);
  const sameDeliveryAddress = context.installationAddress;
  const setSameDeliveryAddress = context.setInstallationAddress;

  props.enableNext(true);
  const [formData, setFormData] = useState({
    formComponents: {
      unitNumber: {
        name: 'Unit number ',
        type: 'input',
        value: sameDeliveryAddress.unitNumber?.trim(),
        width: 30,
        optional: true,
        validations: {
          required: false,
          maxLength: 5,
          invalidMessage: 'Please enter a valid unit number'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: '#',
        },
        isValid: true,
        isTouched: false
      },
      buildingName: {
        name: 'Complex/building name ',
        type: 'input',
        value: sameDeliveryAddress.buildingName?.trim(),
        width: 70,
        optional: true,
        validations: {
          required: false
        },
        config: {
          type: 'text',
          required: true,
          maxLength: 30,
          placeholder: 'Enter complex/building name'
        },
        isValid: true,
        isTouched: false
      },
      streetNo: {
        name: 'Street no.',
        type: 'input',
        value: sameDeliveryAddress.streetNumber,
        width: 30,
        validations: {
          required: false
        },
        config: {
          type: 'text',
          required: true,
          disabled: true,
        },
        isValid: true,
        isTouched: false
      },
      streetName: {
        name: 'Street name',
        type: 'input',
        value: sameDeliveryAddress.streetName,
        width: 70,
        validations: {
          required: false
        },
        config: {
          type: 'text',
          disabled: true
        },
        isValid: true,
        isTouched: false
      },
      suburb: {
        name: 'Suburb',
        type: 'input',
        value: sameDeliveryAddress.suburb,
        width: 70,
        validations: {
          required: false
        },
        config: {
          type: 'text',
          disabled: true
        },
        isValid: true,
        isTouched: false
      },
      postCode: {
        name: 'Postal code',
        type: 'input',
        value: sameDeliveryAddress.postalCode,
        width: 30,
        validations: {
          required: false
        },
        config: {
          type: 'text',
          disabled: true
        },
        isValid: true,
        isTouched: false
      },
      town: {
        name: 'Town/city',
        type: 'input',
        value: sameDeliveryAddress.city,
        width: 70,
        validations: {
          required: false
        },
        config: {
          type: 'text',
          disabled: true
        },
        isValid: true,
        isTouched: false
      },
      province: {
        name: 'Province',
        type: 'dropDown',
        value: sameDeliveryAddress.province,
        extraClass: 'disableDropDown',
        width: 30,
        options: [],
        validations: {
          required: false,
          invalidMessage: 'Please select ID type',
        },
        config: {
          type: 'select'
        },
        isValid: true,
        isTouched: false
      },
    }
  });

  const formCompArray = [];
  for (let key in formData.formComponents) {
    formCompArray.push({
      key: key,
      config: formData.formComponents[key]
    });
  }

  const formComponentChangeHandler = (value, inputIdentifier) => {
    const formCompsCopy = { ...formData.formComponents };
    const changedComponent = { ...formCompsCopy[inputIdentifier] };
    changedComponent.value = value;
    if (inputIdentifier === 'postCode' || inputIdentifier === 'unitNumber'|| inputIdentifier === 'streetNo') {
      changedComponent.value = value.trim();
    }
    else {
      changedComponent.value = value;
    }
    changedComponent.isValid = checkInputValidity(
      changedComponent.value,
      changedComponent.validations
    );

    const newAddress = { ...context.installationAddress, [inputIdentifier]: changedComponent.value };
    setSameDeliveryAddress(newAddress);
    context.setInstallationAddress(newAddress);

    changedComponent.isTouched = true;

    const newFormComps = {
      ...formCompsCopy,
      [inputIdentifier]: changedComponent
    }

    const isFormValid = !Object.keys(newFormComps).find(e => newFormComps[e].isValid === false) ? true : false;

    setFormData({
      formComponents: newFormComps,
      isFormValid: isFormValid
    });
  };

  return (
    <div className="same-address-wrapper">
      {
        formCompArray.map((item, index) => {
          return (
            <div className={`delivery-field-wrapper-${item?.config?.width}`} key={index}>
              <FormFieldLabel>
                {item.config.name}
                {
                  item?.config?.optional && <span className="vetting-optional-text"> (Optional)</span>
                }
              </FormFieldLabel>

              {
                item.config.type === 'input' &&
                  <VettingInput
                    {...item.config}
                    inputIdentifier={item.key}
                    updateValue={(value) => formComponentChangeHandler(value, item.key)}
                  />
              }
              {
                item.config.type === 'dropDown' &&
                  <VettingDropDown
                    {...item.config}
                    selectedValue={item.config?.value}
                    placeholder={item.config?.config?.placeholder}
                  />
              }
            </div>
          )
        })
      }
    </div>
  )
}

SameAddress.propTypes = {
  enableNext: PropTypes.func,
};

export default SameAddress;